import { DefaultState } from 'store/reducers/types';

export const SET_RECRUITER_IDS_SUCCESS = "SET_RECRUITER_ID_SUCCESS";

export interface RecruiterIdsData {
  recruiterIds: number[];
};

export type RecruiterIdsState = DefaultState & {
  contents: RecruiterIdsData;
};

interface SetRecruiterIdsDataSuccess {
  type: typeof SET_RECRUITER_IDS_SUCCESS,
  contents: RecruiterIdsData
}

export type RecruiterIdsActionTypes = SetRecruiterIdsDataSuccess;